import React, { useState, useEffect } from "react";
import "./Style/SchoolLogin.css";
import "./Style/Header.css";
import "./Style/Common.css";
import SchoolLoginBg from "./Image/login_bg2.jpg";
import SchoolLoginImg from "./Image/fr_school_code.png";
import SchoolLoginTittle from "./Image/bar_titles_log_in_school.png";
import SchoolCodeRed from "./Image/fr_school_code_red.png";
import UserRed from "./Image/fr_userid_red.png";
import PassRed from "./Image/fr_password_red.png";
import { decryptPayload } from "../Common/utils/Decrypt";
import Loading from "../Common/Loading";

const SchoolLogin: React.FC = () => {
  const [schoolCode, setSchoolCode] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [tooltiptext, setTooltipText] = useState("Show password");
  const [loading, setLoading] = useState(false);

  const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK ;

  useEffect(() => {
    const handleEnterKey = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        document
          .getElementById("form1")
          ?.dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
          );
      }
    };

    const form = document.getElementById("form1");
    form?.addEventListener("keydown", handleEnterKey);

    return () => {
      form?.removeEventListener("keydown", handleEnterKey);
    };
  }, []);

  useEffect(() => {
    const handleResizeAndStyle = () => {
      Object.assign(document.body.style, {
        height: `${window.innerHeight - 40}px`,
        width: `${window.innerWidth}px`,
        backgroundImage: `url(${SchoolLoginBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundAttachment: "fixed",
        backgroundColor: "#32495f",
        minWidth: "100%",
        minHeight: "100%",
      });
    };

    handleResizeAndStyle();
    window.addEventListener("resize", handleResizeAndStyle);

    const btLogin = document.getElementById("bt_login");
    if (btLogin) btLogin.style.backgroundImage = `url(${SchoolLoginTittle})`;

    const schoolInput = document.getElementById("txtSchoolCode");
    if (schoolInput)
      schoolInput.style.backgroundImage = `url(${SchoolLoginImg})`;

    return () => {
      window.removeEventListener("resize", handleResizeAndStyle);
      Object.assign(document.body.style, {
        backgroundImage: "",
        backgroundSize: "",
        backgroundRepeat: "",
        backgroundPosition: "",
        backgroundAttachment: "",
        backgroundColor: "",
        minWidth: "",
        minHeight: "",
        height: "",
        width: "",
      });
    };
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!schoolCode || !userName || !password) {
      setError("Please enter all required fields.");
      return;
    }
    setError("");
    setLoading(true); 

    try {
      const response = await fetch(`${apiUrl}school_login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          SchoolCode: schoolCode,
          username: userName,
          password: password,
        }),
      });

      const raw = await response.json();
      const data = decryptPayload(raw.data);

      if (data.status === "ok" && data.redirect) {
        window.location.href = data.redirect;
      } else {
        setError(data.message || "Login failed.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false) 
    }
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => {
      setTooltipText(!prev ? "Hide password" : "Show password");
      return !prev;
    });
  };

  return (
    <form id="form1" onSubmit={handleLogin}>
   
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loading />
        </div>
      )}

      <div id="pannelMain">
        <div>
          <div id="main_top_container">
            <div
              id="login_title_bar"
              className="section_container section_title_bar"
            >
              <div id="bt_login" className="section_div bar_section">
                <p className="bar_title" />
              </div>
            </div>
          </div>

          <br />
          <br />
          <div
            id="browser_name_message"
            className="subject_container_title subject_container_title_sbg"
            style={{ display: "none" }}
          >
            <p>
              Please use standard Browsers like Chrome, Firefox, Safari,
              Internet Explorer or Microsoft Edge.
            </p>
          </div>

          <div id="login" className="section_container">
            <div id="login_form_box">
              <input
                type="text"
                id="txtSchoolCode"
                tabIndex={1}
                maxLength={50}
                value={schoolCode}
                onChange={(e) => setSchoolCode(e.target.value)}
                placeholder="School Code"
                
                className={`login_field login_school_code ${
                  error && !schoolCode ? "red_input" : ""
                }`}
                style={{
                  paddingLeft: "55px",
                  ...(error && !schoolCode
                    ? { backgroundImage: `url(${SchoolCodeRed})`, background: "#FCFCFC", paddingLeft: "55px" }
                    : {})
                }}
              />
              <div className="divider" />
              <input
                type="text"
                id="txtUserName"
                tabIndex={2}
                maxLength={50}
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                placeholder="Login ID"
                className={`login_field login_userid ${
                  error && !userName ? "red_input" : ""
                }`}
                style={
                  error && !userName
                    ? { backgroundImage: `url(${UserRed})` }
                    : {}
                }
              />
              <div className="divider" />
              <input
                type={isPasswordVisible ? "text" : "password"}
                id="txtPassword"
                tabIndex={3}
                maxLength={50}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className={`login_field login_password ${
                  error && !password ? "red_input" : ""
                }`}
                style={
                  error && !password
                    ? { backgroundImage: `url(${PassRed})` }
                    : {}
                }
              />
              <span
                id="password_icon_container"
                onClick={togglePasswordVisibility}
                tabIndex={4}
                role="button"
                aria-label="Toggle password visibility"
              >
                <span
                  className={`show_hide_password_icon ${
                    isPasswordVisible ? "toggle_password" : ""
                  }`}
                >
                  <span className="tooltiptext">{tooltiptext}</span>
                </span>
              </span>
            </div>

            {error && (
              <p id="alert_text">
                <span className="flash">{error}</span>
              </p>
            )}
            <div className="button_box">
              <div
                id="login_btn"
                className="general_btn two_btn"
                style={{ marginTop: "45px" }}
              >
                <a
                  href="#"
                  className="login_submit_button"
                  tabIndex={5}
                  onClick={(e) => {
                    e.preventDefault(); // stop navigation
                    document
                      .getElementById("form1")
                      ?.dispatchEvent(
                        new Event("submit", {
                          cancelable: true,
                          bubbles: true,
                        })
                      );
                  }}
                >
                  Log In
                </a>
              </div>
            </div>

            <p className="page_text_smlT">
              <a
                href="/Login/ForgotPassword.aspx?UserType=SchoolLogin"
                target="_blank"
                className="page_link"
                tabIndex={6}
              >
                Forgotten my password
              </a>
              <span className="text_breaker" />
            </p>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SchoolLogin;
